const $ = require("jquery");
const { Foundation, dataLayer } = window;
const FormController = require("../../utilities/_form-controller");
const _ = require("lodash");
const Stepper = require("../stepper/Stepper");
const Form_init = require("../../src/Form_init");

class PartnerForm1056 {
    constructor (id, utmCookies) {
        this.id = id;
        this.setupForm();
        this.stepper = new Stepper(this.getStepperId());
        utmCookies.initForm(this.getForm()[0]);
    }

    setupForm () {
        new Foundation.Abide(this.getForm());

        const $form = this.getForm();

        $form
            .on("formvalid.zf.abide", () => this.submit())
            .on("submit", e => e.preventDefault());

        const form = $form[0];

        Form_init(form);
    }

    getRoot () {
        return $(`#${this.id}`);
    }

    getRootElement() {
        return this.getRoot()[0];
    }

    getStepper () {
        return this.getRoot().find("[data-component=stepper]");
    }

    getStepperId () {
        return this.getStepper().attr("id");
    }

    getForm () {
        return this.getRoot().find("form");
    }

    getFormId () {
        return this.getForm().attr("id");
    }

    getCountryField () {
        return this.getForm().find('[name="Country"]');
    }

    getPrivacyPolicyAgreementMessageContainer() {
        return this.getForm().find('[data-component="privacy-policy-agreement-message-container"]');
    }

    getPrivacyPolicyCheckboxContainer() {
        return this.getForm().find('[data-component="privacy-policy-checkbox-container"]');
    }

    getSubmitButton () {
        return this.getForm().find("button[type=submit]");
    }

    disableSubmitButton () {
        this.getSubmitButton().attr("disabled", "true");
    }

    serializeFormData () {
        return _.reduce(
            this.getForm().serializeArray(),
            (data, field) => _.set(data, field.name, field.value),
            {}
        );
    }

    async submit () {
        this.disableSubmitButton();

        this.stepper.nextStep();

        const data = this.serializeFormData();

        try {
            await FormController.marketo__submit(data, undefined, undefined, this.getForm());
            dataLayer.push({ event: 'ajaxFormSubmitted' });
        } catch (e) {
            console.error(e);
        } finally {
            this.stepper.nextStep();
        }
    }
}

PartnerForm1056.init = (utmCookies) => {
    const objects = [];

    $('[data-component="partner-form-1056"]').each((i, e) => {
        const id = $(e).attr("id");
        objects.push(new PartnerForm1056(id, utmCookies));
    });

    return objects;
}

module.exports = PartnerForm1056;
